import { createStore, createHook, type StoreActionApi } from 'react-sweet-state';

export interface GeneratedTitleState {
	generatedTitle: string;
	trackAIResultViewStored: (attribute: any) => void;
}

export const initialState: GeneratedTitleState = {
	generatedTitle: '',
	trackAIResultViewStored: () => {},
};

const NAME = 'GENERATED_TITLE_STORE';

export const actions = {
	setGeneratedTitle:
		(newTitle: string) =>
		({ setState }: StoreActionApi<GeneratedTitleState>) => {
			setState({ generatedTitle: newTitle });
		},
	setTrackAIResultViewStored:
		(trackAIResultViewHook: (attribute: any) => void) =>
		({ setState }: StoreActionApi<GeneratedTitleState>) => {
			setState({ trackAIResultViewStored: trackAIResultViewHook });
		},
};

const GeneratedTitleStore = createStore({
	name: NAME,
	initialState,
	actions,
});

export const useGeneratedTitle = createHook(GeneratedTitleStore);
